import { render } from "./CategoryPage.vue?vue&type=template&id=531b6f45&scoped=true&ts=true"
import script from "./CategoryPage.vue?vue&type=script&lang=ts"
export * from "./CategoryPage.vue?vue&type=script&lang=ts"

import "./CategoryPage.vue?vue&type=style&index=0&id=531b6f45&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531b6f45"]])

export default __exports__